import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { deleteAdminReview } from '../../../shared/api/reviews.services';
import toast from '../../../shared/lib/toast';

const ReviewsItem = ({ review }) => {
  const navigate = useNavigate();
  const [isDeleted, setIsDeleted] = useState(false);

  if (isDeleted) return null;

  const getLocalizedValue = (field) => {
    if (!field) return '';
    if (typeof field === 'string') return field;
    if (typeof field === 'object') {
      return field.ua || field.en || '';
    }
    return '';
  };

  const authorName = getLocalizedValue(review?.author?.name) || "Анонім";
  const authorSubtitle = getLocalizedValue(review?.author?.subtitle) || "";
  const dateSource = review?.updatedAt || review?.createdAt;
  const isActive = review?.isActive !== false;
  const statusLabel = isActive ? 'Активний' : 'Неактивний';

  const formatDate = (isoDate) => {
    if (!isoDate) return 'Дата';
    const dateObj = new Date(isoDate);
    if (Number.isNaN(dateObj.getTime())) return 'Дата';

    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const year = dateObj.getFullYear();
    return `${day}.${month}.${year}`;
  };

  const handleDelete = async () => {
    if (window.confirm('Ви впевнені, що хочете видалити цей відгук?')) {
      try {
        const response = await deleteAdminReview(review?.id);
        if (response?.ok || !response?.error) {
          toast.success('Відгук успішно видалено!');
          setIsDeleted(true);
        } else {
          toast.error(response?.message || 'Помилка при видаленні');
        }
      } catch (error) {
        console.error('Error deleting review:', error);
        toast.error('Помилка при видаленні');
      }
    }
  };

  return (
    <div className='team-item team-grid'>
      <div className="team-item__info">
        <div className="team-item__info-txt">
          <p className='team_name'>{authorName}</p>
          <p style={{ fontSize: '12px', color: '#666' }}>{authorSubtitle}</p>
        </div>
      </div>

      <div className="team-item__info">
        <div className="team-item__info-txt">
          <p style={{ fontSize: '12px' }}>{formatDate(dateSource)}</p>
        </div>
      </div>

      <div className="team-item__info">
        <div className={`team-item__status ${isActive ? 'is-visible' : 'is-hidden'}`}>
          <p>{statusLabel}</p>
        </div>
      </div>

      <div className="team-item__func">
        <button
          onClick={() => navigate(`/review-rewrite/${review?.id}`)}
          className='func-rewrite'
          style={{
            backgroundColor: '#081249',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            padding: '6px 12px',
            cursor: 'pointer'
          }}
        >
          Редагувати
        </button>
        <button
          onClick={handleDelete}
          className='func-delete'
          style={{
            backgroundColor: '#FE0707',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            padding: '6px 12px',
            cursor: 'pointer'
          }}
        >
          Видалити
        </button>
      </div>
    </div>
  );
};

export default ReviewsItem;